module.exports = __webpack_public_path__ + "img/bg_note_05.bc0824d5.jpg";